export default __webpack_public_path__ + "static/media/cert-E-commerce-HKIRC.989dfc3a.jpg";